<template>
  <div>
    <v-container v-if="!orderDetails" fill-height fluid>
      <v-row no-gutters v-if="loading">
        <v-progress-linear
          indeterminate
          color="primary"
          :size="50"
          :width="4"
        ></v-progress-linear>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row no-gutters class="mb-3">
        <v-btn icon class="mr-3" @click="$router.push({name: 'Order History'})" color="grey lighten-1">
          <v-icon>mdi-backburger</v-icon>
        </v-btn>
        <h2>{{orderDetails.orderNumber}}</h2>
        <v-spacer></v-spacer>
        <invoice
          :orderNumber="orderDetails.orderNumber"
          :orderDate="orderDetails.openedOn"
          :productType="orderDetails.productType"
          :searchCost="orderDetails.searchCost"
          :originalSearchCost="orderDetails.originalSearchCost"
          :customerEmail="$store.state.auth.user.email"
          :paymentDetails="orderDetails.paymentDetails"
          :promoCode="orderDetails.promoCodes"
          :customerFirstName="$store.state.auth.user.firstName"
          :customerLastName="$store.state.auth.user.lastName"
        ></invoice>
        <v-btn class="ml-3" v-if="orderDetails && orderDetails.documents.length > 0" @click="downloadCompletedOrder(orderDetails.documents[0].file)">Download Order</v-btn>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col>
          <h2>Property Address</h2>
          <v-row>
            <v-col>
              {{ orderDetails.address }}<span v-if="!!orderDetails.address2">, {{ orderDetails.address2 }}</span><br/>
              {{ orderDetails.city }}, {{ orderDetails.state }} {{ orderDetails.zip }}
            </v-col>
          </v-row>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col>
          <h2>Additional Information</h2>
          <v-row>
            <v-col cols="auto">
              <div>Parcel #:</div>
              <div>Property Owner:</div>
              <div>Additional Info:</div>
            </v-col>
            <v-col>
              <div>{{orderDetails.parcelNumber}}</div>
              <div>{{orderDetails.ownerName}}</div>
              <div>{{orderDetails.additionalInfo}} </div>
            </v-col>
          </v-row>
        </v-col>
        <v-divider v-if="['Document Retrieval', 'Specific Mortgage Search'].includes(orderDetails.productType)" vertical></v-divider>
        <v-col v-if="['Document Retrieval', 'Specific Mortgage Search'].includes(orderDetails.productType)">
          <h2>Mortgage Information</h2>
          <v-row v-if="orderDetails.productType == 'Document Retrieval'">
            <v-col cols="auto">
                <div v-if="orderDetails.productType === 'Document Retrieval'">
                  Documents Requested:
                </div>
                <div>Mortgage Amount:</div>
                <div>Est. Recording Date:</div>
                <div>Grantor/Grantee:</div>
                <div>Book #:</div>
                <div>Page #:</div>
                <div>Instrument #:</div>
              </v-col>
              <v-col>
                <div v-if="orderDetails.productType === 'Document Retrieval'">
                  {{ orderDetails.requestedDocumentTypes.map((type) => type.name).join(', ') }}
                </div>
                <div>{{ orderDetails.mortgageAmount }}</div>
                <div>{{ orderDetails.estimatedRecordingDate }}</div>
                <div>{{ orderDetails.grantorGrantee }}</div>
                <div>{{ orderDetails.bookNumber }}</div>
                <div>{{ orderDetails.pageNumber }}</div>
                <div>{{ orderDetails.instrumentNumber }}</div>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col>
          <status-update-list :statusUpdates="orderDetails.statusUpdates"></status-update-list>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getOrderDetail } from '@/services/api/orders'
import StatusUpdateList from "@/components/orders/StatusUpdateList.vue";
import Invoice from '@/components/orders/Invoice.vue';

export default {
  name: "OrderDetails",
  components: { StatusUpdateList, Invoice },
  data: () => {
    return {
      loading: false,
      orderDetails: null,
    }
  },
  mounted() {
    this.updateWindowTitle({ newTitle: "Order Detail" });
    this.loadOrderDetails()
  },
  props: ['id'],
  methods: {
    ...mapActions(["updateWindowTitle"]),
    loadOrderDetails() {
      this.loading = true;
      getOrderDetail(this.id)
      .then((resp) => {
        this.orderDetails = resp 
        this.loading = false
      })
    },
    forceDownload(blob, filename) {
      var a = document.createElement('a');
      a.download = filename;
      a.href = blob;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    downloadCompletedOrder(url) {
      fetch(url, {
        headers: new Headers({
          'Origin': location.origin
        }),
        mode: 'cors'
      })
      .then(response => response.blob())
      .then(blob => {
        let blobUrl = window.URL.createObjectURL(blob);
        this.forceDownload(blobUrl, this.orderDetails.orderNumber + '.pdf');
      })
      .catch(e => console.error(e));
    }
  },
};
</script>
